/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentDataExtractorTypes.yaml
import { DocumentDataExtractorConfigurationElement } from '../document_data_extractor/DocumentDataExtractorConfigurationTypes';
import { DocumentDetectionResult } from '../document_scanner/DocumentScannerTypes';
import { GenericDocument } from '../documents/GenericDocument';
import { ResultAccumulationConfiguration } from '../frame_accumulation/FrameAccumulationTypes';
import { ImageRef } from '../imageRef/image';
import { ToJsonConfiguration } from '../utils/json/JsonSerializationTypes';
import { PartiallyConstructible } from '../utils/utils';
export const DocumentDataExtractionStatusValues = [
    'SUCCESS',
    'ERROR_NOTHING_FOUND',
    'ERROR_BAD_CROP',
    'ERROR_UNKNOWN_DOCUMENT',
    'ERROR_UNACCEPTABLE_DOCUMENT',
    'INCOMPLETE_VALIDATION',
];
/**
Contains the result of running the generic document extractor.
*/
export class DocumentDataExtractionResult extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractionResult>`} */
    constructor(source = {}) {
        super();
        /**
          Crop of the document if it was detected.
          */
        this.croppedImage = null;
        this._released = false;
        if (source.status !== undefined) {
            this.status = source.status;
        }
        else {
            throw new Error('status must be present in constructor argument');
        }
        if (source.document !== undefined) {
            this.document = source.document != null ? new GenericDocument(source.document) : null;
        }
        else {
            throw new Error('document must be present in constructor argument');
        }
        if (source.documentDetectionResult !== undefined) {
            this.documentDetectionResult = new DocumentDetectionResult(source.documentDetectionResult);
        }
        else {
            throw new Error('documentDetectionResult must be present in constructor argument');
        }
        if (source.croppedImage !== undefined) {
            this.croppedImage = source.croppedImage != null ? ImageRef.From(source.croppedImage) : null;
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            status: this.status,
            document: this.document != null ? await this.document.serialize(config) : null,
            documentDetectionResult: this.documentDetectionResult.serialize(config),
            croppedImage: config.serializeImages
                ? this.croppedImage != null
                    ? await this.croppedImage.serialize(config.imageSerializationMode)
                    : null
                : undefined,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.document != null) {
                this.document.release();
            }
        }
        {
            if (this.croppedImage != null) {
                this.croppedImage.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.document != null) {
            await this.document.encodeImages();
        }
        if (this.croppedImage != null) {
            await this.croppedImage.encodeInPlace();
        }
    }
}
export const DocumentDataExtractionModeValues = ['LIVE', 'SINGLE_SHOT'];
/**
Parameters for the extraction process.
*/
export class DocumentDataFrameExtractionParameters extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentDataFrameExtractionParameters>`} */
    constructor(source = {}) {
        super();
        /**
          The extraction mode.
          
          Default is LIVE
          */
        this.mode = 'LIVE';
        if (source.mode !== undefined) {
            this.mode = source.mode;
        }
    }
}
/**
Configuration for the document data extractor.
*/
export class DocumentDataExtractorConfiguration extends PartiallyConstructible {
    /** @param source {@displayType `DeepPartial<DocumentDataExtractorConfiguration>`} */
    constructor(source = {}) {
        super();
        /**
          Configuration for how to accumulate results.
          */
        this.resultAccumulationConfig = new ResultAccumulationConfiguration({});
        /**
          Normalized names of the fields to exclude from the result.
          */
        this.fieldExcludeList = [];
        /**
          If true, crops of the detected documents and fields will be returned in the result.
          
          Default is false
          */
        this.returnCrops = false;
        if (source.resultAccumulationConfig !== undefined) {
            this.resultAccumulationConfig = new ResultAccumulationConfiguration(source.resultAccumulationConfig);
        }
        if (source.fieldExcludeList !== undefined) {
            this.fieldExcludeList = source.fieldExcludeList.map((it) => {
                return it;
            });
        }
        if (source.configurations !== undefined) {
            this.configurations = source.configurations.map((it) => {
                return DocumentDataExtractorConfigurationElement.From(it);
            });
        }
        else {
            throw new Error('configurations must be present in constructor argument');
        }
        if (source.returnCrops !== undefined) {
            this.returnCrops = source.returnCrops;
        }
    }
}
//# sourceMappingURL=DocumentDataExtractorTypes.js.map